import { makeAutoObservable, runInAction } from 'mobx'
import { Item, Items } from 'type/Item'
import { Product } from 'type/Product'
import { SearchRequest } from 'type/Search'
import { fetchJson } from 'util/fetch'

const LIMIT = 20

export class CarouselItemsStore {
  private readonly group_id: string
  private readonly limit: number
  private _items: Item[] = []
  private _index = 0
  private _busy = false

  constructor(product: Product, limit = LIMIT) {
    this.group_id = product.group
    this.limit = limit
    makeAutoObservable(this)
  }

  get items(): Item[] {
    return this._items
  }

  get busy(): boolean {
    return this._busy
  }

  get index(): number {
    return this._index
  }

  set index(value: number) {
    this._index = value
  }

  get item(): Item | undefined {
    return this._items[this._index]
  }

  async load() {
    if (this._busy) return
    runInAction(() => this._busy = true)
    const request: SearchRequest = {
      group_id: this.group_id,
      query: '',
      page: 1,
      limit: this.limit,
      sort_by: [{ created_at: 'desc' }],
    }
    try {
      const data: Items = await fetchJson<Items>('/api/stand/items', {
        method: 'POST',
        body: JSON.stringify(request),
      })
      runInAction(() => {
        this._items = data.items
        this._index = 0
      })
    } catch (e) {
      console.error('load welcome items failed', e)
    } finally {
      runInAction(() => this._busy = false)
    }
  }
}

export function itemImage(item: Item): string | undefined {
  const [image] = item.images
  return image
}
